



























































import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import NotificationArea from '@/UI/App/Layout/Header/NotificationArea.vue'

const accountStore = namespace('account')

@Component({
  components: {
    NotificationArea
  }
})

export default class Header extends Vue {
  @accountStore.Getter
  username!: string

  @accountStore.Getter
  accountId!: string

  get visibleName (): string {
    if (this.username !== '') {
      return this.username
    }

    return this.accountId
  }
}
